import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_MAGENTA } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/on-and-on.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/on-and-on-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/on-and-on-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/on-and-on-extreme.circles.json' with { type: 'json' };

export const ON_AND_ON_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'on-and-on',
  baseTitle: "On & On",
  description: "Easy intro track. Cartoon's vocal-led electro-pop, charted as wave-mode runs.",
  difficulty: 1,
  palette: PALETTE_MAGENTA,
  audioSrc: '/audio/waves/on-and-on.mp3',
  attribution: "\"On & On\" by Cartoon (feat. Daniel Levi) [NCS Release] - https://ncs.io/onandon",
  mapper: "Sylas & browiec",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 87, offsetMs: 0, totalBeats: 90 },
    hard: { bpm: 87, offsetMs: 0, totalBeats: 90 },
    extreme: { bpm: 87, offsetMs: 0, totalBeats: 90 },
  },
});
